<convfact-paymentcard-form [paymentCardUid]="paymentCardUid" [paymentCardType]="paymentCardType"
    (saved)="returnToList()" (cancelled)="returnToList()">
</convfact-paymentcard-form>